
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:myProfile:BeforeUpdate', function(event){
    var e_data =  event.detail.params;
    var accept_marketing_val = Flits('#flits-general-subscription').is(':checked') ? 1 : 0
    e_data.push({"name":"accepts_marketing","value":(Flits('#flits-general-subscription').is(':checked')) ? 1 : 0}); 
    Flits("#flits-general-subscription").is(":checked") ? Flits(".flits-accepts-marketing-label").html("Yes") : Flits(".flits-accepts-marketing-label").html("No");
  });
}(Flits));
